/* assets/guia-fijaciones.js — Guía accesorios red de camuflaje */
/* VARIANTS, P, BASE son inyectados por Liquid en la sección */

var TRI_SIZES=[
  {label:'2 × 2 × 2 m',sides:[2,2,2]},
  {label:'3 × 3 × 3 m',sides:[3,3,3]},
  {label:'3 × 4 × 5 m',sides:[3,4,5]},
  {label:'4 × 4 × 4 m',sides:[4,4,4]},
  {label:'5 × 5 × 5 m',sides:[5,5,5]}
];

var ICONS_MAP={'terrasse-mur':'i-home','pergola-bois':'i-pergola','pergola-metal':'i-grid','terrasse-libre':'i-openspace','arbres':'i-posts','balcon':'i-building'};
var LABELS_MAP={
  'terrasse-mur':'Terraza adosada',
  'pergola-bois':'Pérgola de madera',
  'pergola-metal':'Pérgola metálica / aluminio',
  'terrasse-libre':'Espacio abierto',
  'arbres':'Entre árboles / postes',
  'balcon':'Balcón / barandilla'
};

var a={structure:null,walls:null,shape:null,longueur:null,largeur:null,triSize:null,wallSide:null,coco:null,color:null};
var cartEss=[];
var curStep='welcome';

function getSteps(){
  var steps=['welcome','structure'];
  if(a.structure==='terrasse-mur') steps.push('walls');
  steps.push('shape','size','coco');
  if(a.coco&&a.coco!=='coco') steps.push('color');
  steps.push('result');
  return steps;
}
function curIndex(){return getSteps().indexOf(curStep);}
function stepKey(step){return{structure:'structure',walls:'walls',shape:'shape',size:'size',color:'color',coco:'coco'}[step]||null;}
function sizeAnswered(){
  if(a.shape==='rect'){
    if(!a.longueur||!a.largeur) return false;
    if(needsWallSide()&&!a.wallSide) return false;
    return true;
  }
  return a.shape==='tri'&&a.triSize!==null;
}
function needsWallSide(){return a.structure==='terrasse-mur'&&a.walls==='1'&&a.shape==='rect'&&a.longueur&&a.largeur&&a.longueur!==a.largeur;}

function getSizeKey(){
  if(!a.longueur||!a.largeur) return null;
  var lo=Math.min(a.longueur,a.largeur),hi=Math.max(a.longueur,a.largeur);
  return lo+'x'+hi;
}
function getTriKey(){
  if(a.shape!=='tri'||a.triSize===null) return null;
  return TRI_SIZES[a.triSize].sides.join('x');
}
function getAvailableTypes(){
  var isTri=a.shape==='tri',types=[];
  if(isTri){
    var tk=getTriKey();if(!tk) return [];
    if(FILETS.renforce_tri[tk]) types.push('renforce');
    if(FILETS.coco_tri[tk]) types.push('coco');
  } else {
    var sk=getSizeKey();if(!sk) return [];
    if(FILETS.renforce_rect[sk]) types.push('renforce');
    var hasCable=Object.keys(FILETS.cable).some(function(k){return k.slice(k.lastIndexOf('_')+1)===sk;});
    if(hasCable) types.push('cable');
    if(FILETS.coco_rect[sk]) types.push('coco');
  }
  return types;
}

document.querySelectorAll('.op[data-q]').forEach(function(c){
  c.addEventListener('click',function(){
    var q=c.dataset.q,v=c.dataset.v;a[q]=v;
    document.querySelectorAll('.op[data-q="'+q+'"]').forEach(function(x){x.classList.remove('on');});
    c.classList.add('on');
    if(q==='structure'&&v!=='terrasse-mur') a.walls=null;
    if(q==='shape'){a.longueur=null;a.largeur=null;a.triSize=null;a.wallSide=null;}
    saveState();
    updateNav();
  });
});

function filterColorPanel(){
  var isTri=a.shape==='tri';
  var sk=isTri?getTriKey():getSizeKey();
  var isCable=a.coco==='cable';
  var stockMap=isTri?FILETS.stock_tri:FILETS.stock_rect;
  var shown=0;
  document.querySelectorAll('.clr-op').forEach(function(el){
    var c=el.dataset.color;
    var visible=true;
    if(isCable&&sk) visible=!!(FILETS.cable[c+'_'+sk]);
    else if(sk&&stockMap&&stockMap[c]) visible=!!(stockMap[c][sk]);
    el.style.display=visible?'':'none';
    if(visible) shown++;
    if(!visible&&a.color===c){a.color=null;el.classList.remove('on');}
  });
  var desc=document.querySelector('#p-color .sh p');
  if(desc) desc.textContent=shown+' color'+(shown>1?'es':'')+' disponible'+(shown>1?'s':'')+' para tu talla';
}

function pickColor(el){
  document.querySelectorAll('.clr-op').forEach(function(o){o.classList.remove('on');});
  el.classList.add('on');
  a.color=el.dataset.color;
  saveState();
  updateNav();
}

function populateFiletTypes(){
  var wrap=document.getElementById('filet-type-options');
  if(!wrap) return;
  var types=getAvailableTypes();
  var isTri=a.shape==='tri';
  var h='';
  var typeMap={
    renforce:{icon:'i-filet-renforce',title:'Red reforzada con cordón',desc:'Cordón de poliéster 6mm en todo el contorno'},
    cable:   {icon:'i-filet-cable',   title:'Red reforzada con cable de acero',desc:'Cable de acero recubierto en todo el contorno — más resistente'},
    coco:    {icon:'i-filet-coco',    title:'Red de fibra de coco natural',desc:'Trama y contorno en fibra de coco 100% natural'}
  };
  if(types.length===0){
    h='<div class="tp"><div class="ti"><svg class="ico" style="width:14px;height:14px"><use href="#i-bulb"/></svg></div><div class="tt">Ninguna red disponible para esta talla y color. <a href="'+BASE+'/pages/presupuesto-a-medida" style="color:var(--cd);font-weight:700;">Solicitar presupuesto a medida →</a></div></div>';
  } else {
    types.forEach(function(t){
      var tm=typeMap[t];
      var productUrl='';
      if(t==='cable') productUrl=FILETS.cable_url;
      else if(t==='coco') productUrl=FILETS.coco_url;
      h+='<div class="op'+(a.coco===t?' on':'')+'" data-q="coco" data-v="'+t+'" data-purl="'+productUrl+'">'
        +'<div class="oi"><svg class="ico-scene" style="width:38px;height:34px"><use href="#'+tm.icon+'"/></svg></div>'
        +'<div class="ob"><div class="ot">'+tm.title+'</div><div class="od">'+tm.desc+'</div></div>'
        +'<div class="oc"><svg class="ico"><use href="#i-check"/></svg></div>'
        +'</div>';
    });
  }
  wrap.innerHTML=h;
  // Re-attach click handlers
  wrap.querySelectorAll('.op[data-q]').forEach(function(c2){
    c2.addEventListener('click',function(){
      var q=c2.dataset.q,v=c2.dataset.v;
      if(q==='coco'&&a[q]!==v) a.color=null;
      a[q]=v;
      wrap.querySelectorAll('.op[data-q="'+q+'"]').forEach(function(x){x.classList.remove('on');});
      c2.classList.add('on');
      saveState();
      updateNav();
    });
  });
}

function goTo(step){
  var oldEl=document.getElementById('p-'+curStep);
  oldEl.classList.add('ou');
  setTimeout(function(){
    oldEl.classList.add('hd');oldEl.classList.remove('ou');
    curStep=step;
    saveState();
    if(curStep==='size') populateSizePanel();
    if(curStep==='coco') populateFiletTypes();
    if(curStep==='color') filterColorPanel();
    if(curStep==='result') bR();
    var newEl=document.getElementById('p-'+curStep);
    newEl.classList.remove('hd');newEl.classList.add('ou');
    requestAnimationFrame(function(){requestAnimationFrame(function(){newEl.classList.remove('ou');});});
    updateUI();
    window.scrollTo({top:0,behavior:'smooth'});
  },200);
}
function goNext(){var steps=getSteps();var i=curIndex();if(i<steps.length-1) goTo(steps[i+1]);}
function goPrev(){var steps=getSteps();var i=curIndex();if(i>0) goTo(steps[i-1]);}
function rs(){
  a={structure:null,walls:null,shape:null,longueur:null,largeur:null,triSize:null,wallSide:null,coco:null,color:null};
  document.querySelectorAll('.op,.clr-op').forEach(function(c){c.classList.remove('on');});
  document.getElementById('size-content').innerHTML='';
  try{sessionStorage.removeItem('gac');}catch(e){}
  goTo('welcome');
}

function updateNav(){
  var b=document.getElementById('bN');
  var steps=getSteps();var i=curIndex();
  if(curStep==='welcome'){b.disabled=false;b.innerHTML='Empezar <svg class="ico" style="width:14px;height:14px"><use href="#i-right"/></svg>';return;}
  var key=stepKey(curStep);
  var isLast=i===steps.length-2;
  b.disabled=curStep==='size'?!sizeAnswered():(key&&!a[key]);
  b.innerHTML=(isLast?'Ver mis accesorios ':'Continuar ')+'<svg class="ico" style="width:14px;height:14px"><use href="#i-right"/></svg>';
}

function updateUI(){
  var bnav=document.getElementById('bnav');
  var pa=document.getElementById('pA');
  if(curStep==='welcome'){
    pa.style.display='none';bnav.classList.add('hidden');
  } else if(curStep==='result'){
    pa.style.display='none';bnav.classList.add('hidden');
  } else {
    pa.style.display='block';
    var steps=getSteps();
    var qSteps=steps.filter(function(s){return s!=='welcome'&&s!=='result';});
    var qIdx=qSteps.indexOf(curStep)+1;var qTotal=qSteps.length;
    document.getElementById('pL').textContent='Paso '+qIdx+' / '+qTotal;
    var d='';for(var i=1;i<=qTotal;i++){d+='<div class="gac-sg '+(i<qIdx?'d':i===qIdx?'a':'')+'"></div>';}
    document.getElementById('pB').innerHTML=d;
    bnav.classList.remove('hidden');
  }
  document.getElementById('bB').style.display=curStep!=='welcome'?'':'none';
  updateNav();
}

window.addEventListener('scroll',function(){
  var pa=document.getElementById('pA');
  if(pa) pa.classList.toggle('scrolled',window.scrollY>10);
},{passive:true});

function addToCart(items){
  var data=items.filter(function(x){return VARIANTS[x.k]>0;}).map(function(x){return{id:VARIANTS[x.k],quantity:x.q};});
  if(!data.length){window.location.href=BASE+'/collections/fijacion-red-de-camuflaje';return;}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:data})}).then(function(){window.location.href='/cart';}).catch(function(){window.location.href=BASE+'/collections/fijacion-red-de-camuflaje';});
}
function quitGuide(){if(document.referrer&&document.referrer.indexOf(location.hostname)!==-1){history.back();}else{window.location.href=BASE;}}

function populateSizePanel(){
  var c=document.getElementById('size-content');
  if(a.shape==='rect'){
    var h='<div class="dim-row">';
    h+='<div class="dim-col"><label>Largo</label><select id="sel-long" onchange="onRectChange()"><option value="" disabled selected>— elegir —</option>';
    for(var i=2;i<=10;i++) h+='<option value="'+i+'"'+(a.longueur===i?' selected':'')+'>'+i+' m</option>';
    h+='</select></div>';
    h+='<div class="dim-col"><label>Ancho</label><select id="sel-larg" onchange="onRectChange()"><option value="" disabled selected>— elegir —</option>';
    for(var j=2;j<=10;j++) h+='<option value="'+j+'"'+(a.largeur===j?' selected':'')+'>'+j+' m</option>';
    h+='</select></div></div>';
    h+='<div class="dim-info" id="dim-info" style="display:none"><svg class="ico" style="width:14px;height:14px"><use href="#i-ruler"/></svg><span id="dim-info-text"></span></div>';
    h+='<div id="wallside-wrap" style="display:none"></div>';
    c.innerHTML=h;
    if(a.longueur) updateSecondDropdown(a.longueur);
    if(a.longueur&&a.largeur) onRectChange();
  } else {
    var h2='<div class="dim-full"><label>Dimensiones del triángulo</label><select id="sel-tri" onchange="onTriChange()"><option value="" disabled selected>— elegir —</option>';
    TRI_SIZES.forEach(function(t,idx){h2+='<option value="'+idx+'"'+(a.triSize===idx?' selected':'')+'>'+t.label+'</option>';});
    h2+='</select></div>';
    h2+='<div class="dim-info" id="dim-info" style="display:none"><svg class="ico" style="width:14px;height:14px"><use href="#i-ruler"/></svg><span id="dim-info-text"></span></div>';
    c.innerHTML=h2;
    if(a.triSize!==null) onTriChange();
  }
}

function updateSecondDropdown(L){
  var sel=document.getElementById('sel-larg');
  if(!sel) return;
  sel.querySelectorAll('option').forEach(function(o){
    if(!o.value) return;
    var W=parseInt(o.value);
    var lo=Math.min(L,W),hi=Math.max(L,W),sk=lo+'x'+hi;
    var avail=!!(FILETS.renforce_rect[sk]||FILETS.coco_rect[sk]||
      Object.keys(FILETS.cable).some(function(k){return k.slice(k.lastIndexOf('_')+1)===sk;}));
    o.disabled=!avail;
  });
}

function onRectChange(){
  var selL=document.getElementById('sel-long'),selW=document.getElementById('sel-larg');
  var L=parseInt(selL.value)||0,W=parseInt(selW.value)||0;
  if(L) updateSecondDropdown(L);
  if(L&&W){
    a.longueur=L;a.largeur=W;
    var perim=2*(L+W),surf=L*W;
    var info=document.getElementById('dim-info');
    info.style.display='flex';
    document.getElementById('dim-info-text').innerHTML='<strong>'+L+' × '+W+' m</strong> — '+surf+' m² · Perímetro '+perim+' m';
    showWallSideQuestion();
  }
  saveState();
  updateNav();
}

function wallSvg(wallOnSide1,L,W){
  var vW=58,vH=54,maxRW=32,maxRH=28;
  var scale=Math.min(maxRW/L,maxRH/W);
  var rW=Math.max(14,Math.round(L*scale)),rH=Math.max(10,Math.round(W*scale));
  var rX=4,rY=Math.round((vH-rH)/2);
  var x1=rX,y1=rY,x2=rX+rW,y2=rY+rH;
  var s='<svg width="52" height="48" viewBox="0 0 '+vW+' '+vH+'" fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round">';
  s+='<line x1="'+x1+'" y1="'+y1+'" x2="'+x2+'" y2="'+y1+'" stroke-width="'+(wallOnSide1?'5':'1.5')+'" '+(wallOnSide1?'':'stroke-dasharray="3 2"')+'"/>';
  s+='<line x1="'+x1+'" y1="'+y2+'" x2="'+x2+'" y2="'+y2+'" stroke-width="1.5" stroke-dasharray="3 2"/>';
  s+='<line x1="'+x1+'" y1="'+y1+'" x2="'+x1+'" y2="'+y2+'" stroke-width="'+(wallOnSide1?'1.5':'5')+'" '+(!wallOnSide1?'':'stroke-dasharray="3 2"')+'"/>';
  s+='<line x1="'+x2+'" y1="'+y1+'" x2="'+x2+'" y2="'+y2+'" stroke-width="1.5" stroke-dasharray="3 2"/>';
  s+='<text x="'+Math.round(x1+rW/2)+'" y="'+(y2+11)+'" text-anchor="middle" font-size="8" fill="currentColor" stroke="none" font-family="sans-serif" font-weight="700">'+L+' m</text>';
  s+='<text x="'+(x2+6)+'" y="'+Math.round((y1+y2)/2+3)+'" text-anchor="start" font-size="8" fill="currentColor" stroke="none" font-family="sans-serif" font-weight="700">'+W+' m</text>';
  s+='</svg>';
  return s;
}

function showWallSideQuestion(){
  var wrap=document.getElementById('wallside-wrap');if(!wrap) return;
  if(needsWallSide()){
    var L=a.longueur,W=a.largeur;
    var h='<div style="margin-top:16px;padding-top:16px;border-top:1.5px solid var(--bd)">';
    h+='<div style="font-size:15px;font-weight:700;margin-bottom:4px;color:var(--tx)">¿Qué lado de tu red va junto al muro?</div>';
    h+='<div style="font-size:13px;color:var(--t3);margin-bottom:12px;">El trazo grueso = el muro · los punteados = lado libre</div>';
    h+='<div class="os" style="margin-bottom:0">';
    h+='<div class="op'+(a.wallSide==='long'?' on':'')+'" onclick="pickWallSide(\'long\')" style="padding:14px 16px">'
      +'<div class="oi" style="width:48px;height:48px">'+wallSvg(true,L,W)+'</div>'
      +'<div class="ob"><div class="ot">El muro está en el lado de '+L+' m</div><div class="od">El lado largo está contra el muro — los '+W+' m quedan libres</div></div>'
      +'<div class="oc"><svg class="ico"><use href="#i-check"/></svg></div></div>';
    h+='<div class="op'+(a.wallSide==='short'?' on':'')+'" onclick="pickWallSide(\'short\')" style="padding:14px 16px">'
      +'<div class="oi" style="width:48px;height:48px">'+wallSvg(false,L,W)+'</div>'
      +'<div class="ob"><div class="ot">El muro está en el lado de '+W+' m</div><div class="od">El lado corto está contra el muro — los '+L+' m quedan libres</div></div>'
      +'<div class="oc"><svg class="ico"><use href="#i-check"/></svg></div></div>';
    h+='</div></div>';
    wrap.innerHTML=h;wrap.style.display='block';
  } else {wrap.innerHTML='';wrap.style.display='none';a.wallSide=null;}
}

function pickWallSide(side){
  a.wallSide=side;
  var wrap=document.getElementById('wallside-wrap');
  wrap.querySelectorAll('.op').forEach(function(o){o.classList.remove('on');});
  if(side==='long') wrap.querySelectorAll('.op')[0].classList.add('on');
  else wrap.querySelectorAll('.op')[1].classList.add('on');
  saveState();
  updateNav();
}

function onTriChange(){
  var sel=document.getElementById('sel-tri');var idx=parseInt(sel.value);
  if(!isNaN(idx)){
    a.triSize=idx;var t=TRI_SIZES[idx];var perim=t.sides.reduce(function(s,v){return s+v;},0);
    var info=document.getElementById('dim-info');info.style.display='flex';
    document.getElementById('dim-info-text').innerHTML='<strong>'+t.label+'</strong> — Perímetro '+perim+' m';
  }
  saveState();
  updateNav();
}

function getDimensions(){
  if(a.shape==='rect'&&a.longueur&&a.largeur){var L=a.longueur,W=a.largeur;return{perim:2*(L+W),longest:Math.max(L,W),surface:L*W,sides:[L,W,L,W]};}
  if(a.shape==='tri'&&a.triSize!==null){var t=TRI_SIZES[a.triSize];var p=t.sides.reduce(function(s,v){return s+v;},0);return{perim:p,longest:Math.max.apply(null,t.sides),surface:0,sides:t.sides};}
  return{perim:12,longest:4,surface:12,sides:[4,3,4,3]};
}
function pickRope(p){return p<=7.5?'corde75':p<=15?'corde15':'corde30';}
function pickCable(l){return l<=7.5?'cable75':l<=15?'cable15':'cable30';}
function intMats(len){return Math.max(0,Math.floor((len-1)/4));}

function bR(){
  var st=a.structure,w=parseInt(a.walls)||0,tri=a.shape==='tri',co=a.coco==='coco',isCable=a.coco==='cable';
  var dim=getDimensions();var perim=dim.perim,longest=dim.longest,surface=dim.surface;
  var ess=[],opt=[],cartEssLocal=[];var sd='',tips=[];
  tips.push('No tenses la red al máximo — déjala ligeramente suelta para resistir el viento.');
  tips.push('El lado follaje se coloca hacia abajo, el lado cuerda hacia arriba.');
  tips.push('Elige 25 cm menos por cada lado respecto al espacio real.');
  tips.push('Instálala en primavera y retírala a finales de verano para prolongar su vida útil.');
  var cordeK=pickRope(perim),cableK=pickCable(longest),totalCorners=tri?3:4;
  var sizeLabel=tri?TRI_SIZES[a.triSize].label:(a.longueur+'×'+a.largeur+'m');

  if(st==='terrasse-mur'){
    var heldCorners=w===1?2:w===2?3:totalCorners;
    var freeCorners=Math.max(0,totalCorners-heldCorners);
    var qMat=0;
    if(w===1&&!tri){var wallLen=(a.wallSide==='long')?a.longueur:a.largeur;var perpLen=(a.wallSide==='long')?a.largeur:a.longueur;if(!a.wallSide){wallLen=a.longueur;perpLen=a.largeur;}qMat=2+2*intMats(perpLen)+intMats(wallLen);}
    else if(w===1&&tri){qMat=1;}
    else if(w===2&&!tri){qMat=1+intMats(a.longueur)+intMats(a.largeur);}
    var qKit=w>=3?2:1;
    if(qKit>0) ess.push({k:'kit',q:qKit,w:qKit>1?'2 kits para fijar la red en '+w+' muros':'Fijar la red en el muro de tu casa'});
    if(qMat>0){ess.push({k:'mat',q:qMat,w:qMat+' mástil'+(qMat>1?'es':'')+' para '+(qMat>1?'los lados libres':'el lado libre')});ess.push({k:'base',q:qMat,w:'1 base de anclaje por mástil — imprescindible'});}
    ess.push({k:cordeK,q:1,w:'Cuerda de fijación a juego con la red — '+perim+'m de perímetro'});
    if(qMat>0) opt.push({k:'cliquets',q:1,w:'Montaje rápido y temporal (desmontaje fácil)'});
    opt.push({k:cableK,q:1,w:'Evitar hundimiento en el centro (diagonales) o crear una guía'});
    sd=(w===1?'1 lado en el muro':w+' lados en el muro')+(qMat>0?', '+qMat+' mástil'+(qMat>1?'es':'')+' en '+(qMat>1?'los lados libres':'el lado libre')+'.':' — sin necesidad de mástiles.');
  } else if(st==='pergola-bois'){
    ess.push({k:'colliers',q:1,w:'Fijar la red en los travesaños cada 10-15 cm'});
    ess.push({k:cordeK,q:1,w:'Cuerda de fijación a juego con la red — '+perim+'m de perímetro'});
    opt.push({k:cableK,q:1,w:'Evitar hundimiento en el centro o crear una guía'});
    sd='Bridas en la estructura de madera + cuerdas para la tensión.';
    tips.push('Coloca una brida cada 10-15 cm para evitar bolsas de viento.');
  } else if(st==='pergola-metal'){
    ess.push({k:'colliers',q:1,w:'Fijar la red en los tubos cada 10-15 cm'});
    ess.push({k:cordeK,q:1,w:'Cuerda de fijación a juego con la red — '+perim+'m de perímetro'});
    opt.push({k:cableK,q:1,w:'Evitar hundimiento en el centro o crear una guía'});
    sd='Bridas en la estructura metálica + cuerdas para la tensión.';
    tips.push('Multiplica los puntos de fijación para reducir el efecto vela.');
  } else if(st==='terrasse-libre'){
    var qMatO=tri?totalCorners:4+2*intMats(a.longueur)+2*intMats(a.largeur);
    ess.push({k:'mat',q:qMatO,w:qMatO+' mástiles para crear una pérgola autoportante'});
    ess.push({k:'base',q:qMatO,w:'1 base de anclaje por mástil — imprescindible'});
    ess.push({k:cordeK,q:1,w:'Cuerda de fijación a juego con la red — '+perim+'m de perímetro'});
    opt.push({k:'cliquets',q:1,w:'Montaje rápido y temporal (desmontaje fácil)'});
    opt.push({k:cableK,q:1,w:'Vientos para los mástiles, diagonales anti-hundimiento o guía'});
    sd=qMatO+' mástiles telescópicos con bases de anclaje — instalación autoportante.';
  } else if(st==='arbres'){
    ess.push({k:cableK,q:1,w:'Línea de sujeción entre tus árboles'});
    ess.push({k:cordeK,q:1,w:'Cuerda de fijación a juego con la red — '+perim+'m de perímetro'});
    opt.push({k:'cliquets',q:1,w:'Montaje rápido y temporal (desmontaje fácil)'});
    sd='Cable de acero entre los árboles, red colgada con cuerdas.';
  } else if(st==='balcon'){
    ess.push({k:'colliers',q:1,w:'Fijar la red en la barandilla del balcón'});
    ess.push({k:cordeK,q:1,w:'Cuerda de fijación a juego con la red — '+perim+'m de perímetro'});
    sd='Fijación en la barandilla con bridas de nylon.';
  }

  if(co) opt.push({k:'cordecoco',q:1,w:'Fijación natural a juego con la red de coco'});
  opt.push({k:'borne',q:1,w:'Iluminación solar de ambiente para las noches'});

  var seen={};function dd(ar){var r=[];ar.forEach(function(x){if(!seen[x.k]){seen[x.k]=1;r.push(x);}});return r;}
  ess=dd(ess);opt=dd(opt);
  if(isCable){
    opt=opt.filter(function(x){return x.k!==cableK;});
    if(!seen[cableK]){seen[cableK]=1;ess.push({k:cableK,q:1,w:'Cable acero — línea portante principal de tu red'});}
  }
  var tE=0;ess.forEach(function(x){tE+=P[x.k].p*x.q;});
  var shapeLabel=tri?' (triangular)':' (rectangular)';
  var filetLabel=a.coco==='cable'?' — cable acero':a.coco==='coco'?' — coco':'';
  var filetUrl=a.color&&FILETS.colors[a.color]?(tri?FILETS.colors[a.color].tri_url:FILETS.colors[a.color].url):'';
  if(a.coco==='cable') filetUrl=FILETS.cable_url;
  if(a.coco==='coco') filetUrl=FILETS.coco_url;
  var h='';
  h+='<div class="sm"><div class="si"><svg class="ico" style="width:20px;height:20px"><use href="#i-info"/></svg></div><div class="sd2"><strong>'+LABELS_MAP[st]+' — '+sizeLabel+shapeLabel+'</strong><br>'+sd+'</div></div>';
  var fi=getFiletInfo();
  if(fi){
    h+='<div class="rc">'
      +'<div class="rl re"><svg class="ico" style="width:13px;height:13px"><use href="#i-leaf"/></svg> Tu red</div>'
      +'<div class="pr pr-sel checked" data-bp="'+fi.price+'"'+(fi.vid?' data-fid="'+fi.vid+'"':'')+' onclick="toggleSel(event,this)">'
      +'<div class="ochk"><svg class="ico"><use href="#i-check"/></svg></div>'
      +(fi.img?'<div class="pi re"><img src="'+fi.img+'" alt=""></div>':'')
      +'<div class="pd"><div class="pn2">'+fi.name+'</div>'+(fi.size?'<div class="pw">'+fi.size+'</div>':'')+'</div>'
      +(fi.price?'<div class="pp">'+fm(fi.price)+'</div>':'')
      +(fi.url?'<a href="'+fi.url+'" target="_blank" class="voir-btn" onclick="event.stopPropagation()">Ver</a>':'')
      +'</div>'
      +'</div>';
  }
  if(ess.length){h+='<div class="rc"><div class="rl re"><svg class="ico" style="width:13px;height:13px"><use href="#i-checkcircle"/></svg> Recomendado</div>';ess.forEach(function(x){h+=prRow(x,true);});h+='</div>';}
  if(opt.length){h+='<div class="rc"><div class="rl ro"><svg class="ico" style="width:13px;height:13px"><use href="#i-bulb"/></svg> Opcional</div>';opt.forEach(function(x){h+=prRow(x,false);});h+='</div>';}
  h+='<div class="tot"><div class="strow total"><div class="stl">Total selección</div><div class="stv" id="result-total">'+fm(tE)+'</div></div>'
    +'<div class="trust-row">'
    +'<div class="trust-badge"><svg class="ico" style="width:20px;height:20px;flex-shrink:0"><use href="#i-truck"/></svg><div><div class="trust-t">Envío gratuito 2–4 días</div><div class="trust-s">Con SEUR o Correos Express</div></div></div>'
    +'<div class="trust-div"></div>'
    +'<div class="trust-badge trust-pay-badge"><svg class="ico" style="width:20px;height:20px;flex-shrink:0"><use href="#i-lock"/></svg><div><div class="trust-t">Pago seguro</div><div class="pay-logos">'
    +'<img src="https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/visa.svg" class="pay-icon" alt="Visa">'
    +'<img src="https://cdn.jsdelivr.net/npm/payment-icons@1.1.0/min/flat/mastercard.svg" class="pay-icon" alt="Mastercard">'
    +'<svg class="pay-icon" viewBox="0 0 58 40" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="0.5" y="0.5" width="57" height="39" rx="2.5" fill="url(#cbgr2)" stroke="#F1F1F1"/><path fill-rule="evenodd" clip-rule="evenodd" d="M21.825 19.4075H29.6782C29.6082 17.71 29.2127 15.9599 28.0131 14.8358C26.5842 13.4967 24.0813 13 21.8449 13C19.5172 13 16.943 13.5448 15.5065 14.9815C14.2678 16.2192 14 18.2105 14 19.9996C14 21.8737 14.5239 24.0536 15.8677 25.3093C17.2966 26.6453 19.612 27 21.8449 27C24.0141 27 26.3638 26.5995 27.7844 25.3311C29.201 24.0641 29.6906 21.9301 29.6906 19.9996V19.9906H21.825V19.4075ZM30.2053 19.9909V26.687H41.1298V26.6779C42.7283 26.5908 44 25.1495 44 23.3799C44 21.6095 42.7283 20.0758 41.1298 19.9879V19.9909H30.2053ZM41.0054 13.2804C42.5634 13.2804 43.8 14.6322 43.8 16.338C43.8 17.9528 42.6643 19.2716 41.2196 19.4076H30.2051V13.2706H40.6607C40.725 13.2627 40.8 13.2683 40.8733 13.2737C40.919 13.277 40.964 13.2804 41.0054 13.2804Z" fill="#FEFEFE"/><defs><linearGradient id="cbgr2" x1="15.7319" y1="-5.06532" x2="1.63672" y2="38.2044" gradientUnits="userSpaceOnUse"><stop stop-color="#222E72"/><stop offset="0.591647" stop-color="#40CBFF"/><stop offset="1" stop-color="#3CB792"/></linearGradient></defs></svg>'
    +'<img src="https://api.iconify.design/logos:amex.svg" class="pay-icon pay-logo-bg" alt="Amex">'
    +'<img src="https://api.iconify.design/logos:paypal.svg" class="pay-icon pay-logo-bg" alt="PayPal">'
    +'<img src="https://api.iconify.design/simple-icons:klarna.svg?color=%23000" class="pay-icon pay-logo-bg pay-klarna" alt="Klarna">'
    +'</div></div></div>'
    +'</div></div>';
  h+='<div class="cta-row"><button class="cta-main cta-outline" onclick="addToCartDrawer()"><svg class="ico" style="width:17px;height:17px"><use href="#i-cart"/></svg>Añadir al carrito</button><button class="cta-main green" onclick="buyNow()"><svg class="ico" style="width:17px;height:17px;stroke:#fff"><use href="#i-right"/></svg>Comprar ahora</button></div>';
  h+='<div class="res-nav"><button class="bt bt-g" onclick="rs()"><svg class="ico" style="width:13px;height:13px"><use href="#i-undo"/></svg> Volver a empezar</button><button class="bt bt-g" onclick="goPrev()"><svg class="ico" style="width:13px;height:13px;transform:rotate(180deg)"><use href="#i-right"/></svg> Atrás</button></div>';
  h+='<div class="it"><div class="ih"><svg class="ico" style="width:12px;height:12px"><use href="#i-book"/></svg> Consejos de instalación</div>';
  tips.forEach(function(t){h+='<div class="ir"><svg class="ico" style="width:10px;height:10px"><use href="#i-right"/></svg> '+t+'</div>';});
  h+='</div>';
  document.getElementById('p-result').innerHTML=h;
  updateTotal();
}

function piHtml(p,lv){return p.img?'<img src="'+p.img+'" alt="">'
  :'<svg class="ico" style="width:15px;height:15px"><use href="#'+p.i+'"/></svg>';}
function prRow(x,isEss){
  var p=P[x.k],lt=p.p*x.q,pi=isEss?'re':'ro';
  return '<div class="pr pr-sel'+(isEss?' checked':'')+'" data-k="'+x.k+'" data-bp="'+p.p+'" onclick="toggleSel(event,this)">'
    +'<div class="ochk"><svg class="ico"><use href="#i-check"/></svg></div>'
    +'<div class="pi '+pi+'">'+piHtml(p,pi)+'</div>'
    +'<div class="pd"><div class="pn2">'+p.n+'</div>'+(x.w?'<div class="pw">'+x.w+'</div>':'')+'</div>'
    +'<div class="pqc" onclick="event.stopPropagation()">'
    +'<button class="qb" onclick="qDec(this)">−</button>'
    +'<span class="qn">'+x.q+'</span>'
    +'<button class="qb" onclick="qInc(this)">+</button>'
    +'</div>'
    +'<div class="pp">'+fm(lt)+'</div>'
    +'<a href="'+p.u+'" target="_blank" class="voir-btn" onclick="event.stopPropagation()">Ver</a>'
    +'</div>';
}
function getFiletInfo(){
  var isTri=a.shape==='tri',sk=isTri?getTriKey():getSizeKey();
  if(!sk||!a.coco) return null;
  var fi={url:'',img:'',name:'',size:'',price:0,vid:null};
  if(a.coco==='cable'&&a.color){
    var cv=FILETS.cable[a.color+'_'+sk];
    if(cv&&cv.id){fi.vid=cv.id;fi.price=cv.p;}
    fi.url=FILETS.cable_url;fi.img=FILETS.cable_img;
    fi.name='Red cable acero — '+(FILETS.colors[a.color]?FILETS.colors[a.color].label:a.color);
  } else if(a.coco==='coco'){
    fi.url=FILETS.coco_url;fi.img=FILETS.coco_img;fi.name='Red de coco natural';
  } else if(a.color&&FILETS.colors[a.color]){
    var vm=isTri?FILETS.stock_tri:FILETS.stock_rect;
    var vd=vm[a.color]&&vm[a.color][sk];
    if(vd&&vd.id){fi.vid=vd.id;fi.price=vd.p;}
    fi.url=isTri?FILETS.colors[a.color].tri_url:FILETS.colors[a.color].url;
    fi.img=isTri?FILETS.colors[a.color].tri_img:FILETS.colors[a.color].img;
    fi.name='Red reforzada '+FILETS.colors[a.color].label;
  }
  fi.size=isTri&&a.triSize!==null?TRI_SIZES[a.triSize].label:(a.longueur&&a.largeur?a.longueur+' × '+a.largeur+' m':'');
  return fi;
}
function addFiletToCart(){
  var fi=getFiletInfo();
  if(!fi) return;
  if(!fi.vid){if(fi.url) window.open(fi.url,'_blank');return;}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:[{id:fi.vid,quantity:1}]})})
    .then(function(){window.location.href='/cart';})
    .catch(function(){if(fi.url) window.open(fi.url,'_blank');});
}
function toggleSel(e,el){e.preventDefault();el.classList.toggle('checked');updateTotal();}
function qInc(btn){var r=btn.closest('.pr-sel'),s=r.querySelector('.qn'),q=parseInt(s.textContent)+1;s.textContent=q;r.querySelector('.pp').textContent=fm(parseFloat(r.dataset.bp)*q);updateTotal();}
function qDec(btn){var r=btn.closest('.pr-sel'),s=r.querySelector('.qn'),q=Math.max(1,parseInt(s.textContent)-1);s.textContent=q;r.querySelector('.pp').textContent=fm(parseFloat(r.dataset.bp)*q);updateTotal();}
function updateTotal(){
  var t=0;
  document.querySelectorAll('#p-result .pr-sel.checked').forEach(function(r){
    var q=r.querySelector('.qn')?parseInt(r.querySelector('.qn').textContent):1;
    t+=parseFloat(r.dataset.bp||0)*q;
  });
  var el=document.getElementById('result-total');if(el) el.textContent=fm(t);
}
function doCartAdd(checkout){
  var direct=[],keyed=[];
  document.querySelectorAll('#p-result .pr-sel.checked').forEach(function(r){
    var q=r.querySelector('.qn')?parseInt(r.querySelector('.qn').textContent):1;
    if(r.dataset.fid) direct.push({id:parseInt(r.dataset.fid),quantity:q});
    else if(r.dataset.k) keyed.push({k:r.dataset.k,q:q});
  });
  var data=direct.concat(keyed.filter(function(x){return VARIANTS[x.k]>0;}).map(function(x){return{id:VARIANTS[x.k],quantity:x.q};}));
  if(!data.length){window.location.href=BASE+'/collections/fijacion-red-de-camuflaje';return;}
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:data})})
    .then(function(){
      if(checkout){window.location.href='/checkout';return;}
      var btn=document.querySelector('#cart-icon-bubble,[data-cart-icon],[data-cart-toggle],.js-cart-toggle,cart-icon-bubble,.site-header__cart');
      if(btn) btn.click(); else window.location.href='/cart';
    })
    .catch(function(){window.location.href=BASE+'/collections/fijacion-red-de-camuflaje';});
}
function addToCartDrawer(){doCartAdd(false);}
function buyNow(){doCartAdd(true);}
function fm(n){return n.toFixed(2).replace('.',',')+' €';}

function saveState(){
  try{sessionStorage.setItem('gac',JSON.stringify({a:a,step:curStep}));}catch(e){}
}

function restoreState(){
  try{
    var raw=sessionStorage.getItem('gac');
    if(!raw) return false;
    var sv=JSON.parse(raw);
    if(!sv||!sv.step||sv.step==='welcome') return false;
    a=sv.a;
    curStep=sv.step;
    Object.keys(a).forEach(function(q){
      if(a[q]===null||a[q]===undefined) return;
      var el=document.querySelector('.op[data-q="'+q+'"][data-v="'+a[q]+'"]');
      if(el) el.classList.add('on');
    });
    if(a.color){
      var clrEl=document.querySelector('.clr-op[data-color="'+a.color+'"]');
      if(clrEl) clrEl.classList.add('on');
    }
    document.querySelectorAll('.pn').forEach(function(p){p.classList.add('hd');});
    var cur=document.getElementById('p-'+curStep);
    if(cur) cur.classList.remove('hd');
    if(curStep==='size') populateSizePanel();
    if(curStep==='coco') populateFiletTypes();
    if(curStep==='color') filterColorPanel();
    if(curStep==='result') bR();
    updateUI();
    return true;
  }catch(e){return false;}
}

if(!restoreState()) updateUI();
